<template>
  <!-- <v-container fluid mt-0 pb-0 pt-0 text-xs-center style="height:calc(100vh)"> -->
  <v-container fluid mt-0 pb-0 pt-0 text-xs-center>
    <!-------------- position list toolbar------------->
    <v-layout v-if="positionlist_view" row wrap>
      <v-flex xs12>
        <v-toolbar dense class="mb-2">
          <!-- <v-toolbar-side-icon @click.stop="portfolio_drawer = !portfolio_drawer"></v-toolbar-side-icon> -->
          <!-- <v-toolbar-title>{{ selected_portfolio_title }}</v-toolbar-title> -->
          <v-toolbar-title>Assets</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="add_new_position()">
            <v-icon>add</v-icon>
          </v-btn>
          <!-- <v-btn @click="load_positions_from_key()">
            Load
          </v-btn>-->
        </v-toolbar>

        <!-- <v-card flat style="min-height: 500px;" elevation="5"> -->
        <!-- <v-card flat elevation="0" style="height:calc(100vh - 180px)"> -->
        <v-card flat elevation="0">
          <v-list v-if="position_list.length > 0" two-line>
            <template v-for="(position, index) in position_list">
              <v-list-tile :key="position.name" avatar ripple @click="selecte_position(position)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ position.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ position.address }}</v-list-tile-sub-title>
                  <!-- <v-list-tile-sub-title v-bind:class="{ 'text-danger': addressError }">{{ position.address }}</v-list-tile-sub-title> -->
                  <v-list-tile-sub-title>{{ position.book_value }} 만원</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-list-tile-action-text>{{ position.position_type }}</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 <= position_list.length" :key="index"></v-divider>
            </template>
          </v-list>
          <!-- <v-btn absolute dark fab bottom right @click="add_new_position()" color="grey">
            <v-icon>add</v-icon>
          </v-btn>-->
          <v-layout v-if="position_list.length == 0" column style="height:calc(100vh - 180px)">
            <v-flex xs12>
              <v-layout align-center justify-center fill-height>
                <v-subheader>항목이 없습니다.</v-subheader>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-------------- nevigation ------------->
    <v-navigation-drawer
      v-if="positionlist_view"
      v-model="portfolio_drawer"
      class="grey lighten-2"
      height="500px"
      absolute
      temporary
    >
      <v-list class="pa-1">
        <v-list-tile avatar>
          <!-- <v-list-tile-avatar>
            <img src="https://randomuser.me/api/portraits/men/85.jpg">
          </v-list-tile-avatar>-->
          <v-list-tile-content>
            <v-list-tile-title>{{ userinfo.email }}</v-list-tile-title>
          </v-list-tile-content>
          <v-btn icon>
            <v-icon>add</v-icon>
          </v-btn>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile
          v-for="port in portfolio_list"
          :key="port.title"
          @click.stop="position_list = port.position_list; 
                      portfolio_drawer = !portfolio_drawer;
                      selected_portfolio_title = port.title;"
        >
          <v-list-tile-action>
            <v-icon>{{ port.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ port.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <!-------------- position info toolbar------------->
    <v-layout v-if="!positionlist_view" row wrap>
      <v-toolbar dense class="mb-0">
        <v-btn icon @click="positionlist_view = !positionlist_view">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon @click="delete_position()">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <!-------------- position info ------------->
    <v-layout v-if="!positionlist_view" class="pa-2" row wrap>
      <!-- <v-flex xs6>
        <v-text-field label="Key" v-model="access_key" placeholder="access key"></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-btn color="primary" @click="load_positions_from_key()">Load</v-btn>
      </v-flex>-->
      <v-flex xs12>
        <v-text-field label="이름" v-model="position_info.name"></v-text-field>
      </v-flex>
      <v-flex xs9>
        <v-textarea
          label="주소" rows=2
          :value="position_info.address"
          hint="Hint text"
        ></v-textarea>

        <!-- <v-text-field label="주소" color="grey" disabled v-model="position_info.address"></v-text-field> -->
      </v-flex>
      <v-flex xs3>
        <v-layout row justify-center>
          <v-dialog v-model="address_dialog" persistent max-width="600px" min-height="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">수정</v-btn>
            </template>
            <v-tabs dark color="green lighten-3" show-arrows>
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab v-if="false" key="directInputTabKey" href="#directInputTabKey">Direct Input</v-tab>
              <v-tab v-if="false" key="naverInputTabKey" href="#naverInputTabKey">Naver</v-tab>
              <v-tab key="searchInputTabKey" href="#searchInputTabKey">Search</v-tab>

              <v-tabs-items>
                <v-tab-item key="directInputTabKey" value="directInputTabKey">
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <v-text-field label="Address" v-model="position_info.address"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field
                              label="Legal Dong"
                              required
                              v-model="position_info.legal_dong"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field
                              label="Apt Name"
                              v-model="position_info.apt_name"
                              hint="example of helper text only on focus"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field
                              label="Private Area"
                              required
                              v-model="position_info.private_area"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field label="Region Code" v-model="position_info.region_code"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="address_dialog = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-tab-item>
                <v-tab-item key="naverInputTabKey" value="naverInputTabKey">
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field label="Url" required v-model="position_info.url"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-btn @click="url_check()">check</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="address_dialog = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-tab-item>
                <v-tab-item key="searchInputTabKey" value="searchInputTabKey" max-width="550px" >
                  <v-card >
                    <v-text-field
                      class="pa-3" solo
                      label="Prepend inner"
                      placeholder="주소 검색"
                      prepend-inner-icon="place"
                      v-model="address_keyword" @change="get_address_list"
                    ></v-text-field>

                    <v-list v-if="address_search_results.length > 0" two-line class="ma-0 pa-0">
                      <template v-for="(adress_res, index) in address_search_results"
                      >
                        <v-list-tile v-if="(adress_res.detBdNmList != '') && (adress_res.bdKdcd == '1')"
                          :key="adress_res.bdMgtSn"
                          avatar ripple
                          @click="position_info.juso_address_info = adress_res; 
                          address_dialog=false;
                          position_info.address = adress_res.roadAddr;
                          position_info.name = adress_res.bdNm" >
                          <v-list-tile-content>
                            <v-list-tile-title>{{ adress_res.bdNm }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ adress_res.roadAddr }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider class="ma-0 pa-0" v-if="(index + 1 <= address_search_results.length) && 
                                         (adress_res.detBdNmList != '') && 
                                         (adress_res.bdKdcd == '1')" :key="index"></v-divider>
                      </template>
                    </v-list>

                    <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="address_dialog=false">닫기</v-btn>
                </v-card-actions>
              </v-card>

                    
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
            
          </v-dialog>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs12>{{ position_info.legal_dong }} {{ position_info.apt_name }} {{ position_info.private_area }} {{ position_info.region_code }}</v-flex> -->
      <v-flex xs5>
        <v-text-field label="매입가" suffix="만원" v-model="position_info.book_value"></v-text-field>
      </v-flex>
      <v-flex xs1></v-flex>
      <v-flex xs5>
        <v-text-field label="매매일" type="date" v-model="position_info.book_date"></v-text-field>
      </v-flex>

      <v-flex xs12>
        <v-select v-model="position_info_position_type" :items="['자가','전세', '월세']" label="투자형태"></v-select>
        <!-- <v-btn-toggle v-model="position_info.position_type" mandatory>
          <v-btn flat value="owner_occupied">Owner</v-btn>
          <v-btn flat value="rent">Rent</v-btn>
        </v-btn-toggle>-->
      </v-flex>
      <v-flex
        v-if="position_info.position_type == '전세' || position_info.position_type == '월세'"
        xs12
      >
        <v-card color="blue lighten-5" class="pa-2 mb-3">
          <v-flex xs12>
            <v-checkbox
              v-model="position_info.rent.is_resident"
              label="타인 소유 부동산(보증금을 준 경우)"
              value="vertical"
            ></v-checkbox>
          </v-flex>
          <v-container grid-list-md pa-0>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="보증금" suffix="만원" v-model="position_info.rent.deposit"></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="position_info.position_type == '월세'">
                <v-text-field label="월세" v-model="position_info.rent.monthly_payment"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container grid-list-md pa-0>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="계약일" type="date" v-model="position_info.rent.effective_date"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="만기일" type="date" v-model="position_info.rent.maturity_date"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-select
          v-model="position_info_loan_type"
          item-value="loan_type"
          :items="['없음','고정금리', '변동금리']"
          label="대출"
        ></v-select>

        <!-- <v-checkbox
          v-model="position_info.loan_type"
          :label="`Loan : ${position_info.hasLoan.toString()}`"
        ></v-checkbox>-->
      </v-flex>

      <v-flex xs12 v-if="position_info.loan_type == '고정금리'">
        <v-card color="green lighten-5" class="pa-2">
          <v-container grid-list-md pa-0>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="금액" suffix="만원" v-model="position_info.loan.amount"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="금리" suffix="%" v-model="position_info.loan.rate"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container grid-list-md pa-0>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="계약일" type="date" v-model="position_info.loan.effective_date"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="만기일" type="date" v-model="position_info.loan.maturity_date"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <!-- <v-flex xs12>
        <v-btn color="primary" @click="add_new_position()">Add</v-btn>
        <v-btn color="primary" @click="edit_position()">Edit</v-btn>
        <v-btn color="primary" @click="clear_position()">Clear</v-btn>
      </v-flex>-->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ["userinfo", "portfolio_list"],
  data() {
    return {
      positionlist_view: true,
      portfolio_drawer: false,
      address_dialog: false,
      addressError: true,
      access_key: "",
      address_keyword: "",
      address_search_results: [],
      position_info_position_type: "자가",
      position_info_loan_type: "없음",
      position_info: {
        name: "test name2",
        asset_type: "apartment",
        
        juso_address_info:{},

        address: "test address",
        legal_dong: "test dong",
        apt_name: "test apt",
        private_area: 55.12,
        region_code: 11110,

        book_value: 10000,
        book_date: "2018-10-11",
        //position_type: 0, // 0 : owner_occupied, // 1: rent
        position_type: "자가", // 1: rent
        rent: {
          deposit: 0,
          monthly_payment: 1000,
          is_resident: false,
          effective_date: "2018-10-11",
          maturity_date: "2018-10-11"
        },
        loan_type: "없음", // '고정금리', '변동금리'
        loan: {
          amount: 0,
          rate: 0.03,
          effective_date: "2018-10-11",
          maturity_date: "2018-10-11"
        }
      } // positionInfo end
    };
  },
  methods: {
    position_info_valiation: function() {
      var name = this.position_info.name;
      var name_exist = this.$store.state.selected_portfolio.position_list.some(
        function(item) {
          return item.name == name;
        }
      );

      if (name_exist > 0) {
        console.log("name duplication : " + this.position_info.name);
        return false;
      }

      return true;
    },

    add_new_position: function() {
      //if (!this.position_info_valiation()) return;

      console.log("add start ---------------------------------------");

      var new_position_info = JSON.parse(
        JSON.stringify(this.$store.state.new_position_info_template)
      );
      var today = new Date();
      var today_yyyymmdd = today.toISOString().split("T")[0];

      new_position_info.book_date = today_yyyymmdd;
      new_position_info.rent.effective_date = today_yyyymmdd;
      new_position_info.rent.maturity_date = today_yyyymmdd;
      new_position_info.loan.effective_date = today_yyyymmdd;
      new_position_info.loan.maturity_date = today_yyyymmdd;

      this.position_info = new_position_info;

      var i = 0;
      var roopName = new_position_info.name;
      do {
        i += 1;
        // roopName = roopName + i.toString();
        // console.log(i);
      } while (
        this.position_list.some(function(item) {
          return item.name == roopName + i.toString();
        })
      );

      this.position_info.name = roopName + i.toString();

      this.$store.state.selected_portfolio.position_list.push(
        new_position_info
      );
      this.$store.state.isCalculated = false;
      this.positionlist_view = false;
      console.log("add complete ------------------------------------");
    },
    selecte_position: function(position) {
      this.positionlist_view = false;
      //this.position_info = JSON.parse(JSON.stringify(position));
      this.position_info = position;
    },
    delete_position: function() {
      var name = this.position_info.name;

      this.position_list = this.position_list.filter(function(ele) {
        return ele.name != name;
      });

      this.positionlist_view = true;
    },
    edit_position: function() {
      this.$store.state.isCalculated = false;
      console.log("edit complete");
    },
    clear_position: function() {
      this.$store.state.isCalculated = false;
      this.$store.state.selected_portfolio.position_list = [];
      console.log("clear complete");
    },
    url_check: function() {
      var this_component = this;

      this.$axios
        //.post("http://.post/parse_position_info", {
        .post(this.$store.state.url_end_point + "/parse_position_info", {
          url: this.position_info.url
        })
        .then(function(response) {
          console.log(response.data);
          var message = response.data["message"];

          if (message == "success") {
            this_component.position_info.address = response.data["address"];
            this_component.position_info.legal_dong =
              response.data["legal_dong"];
            this_component.position_info.apt_name = response.data["apt_name"];
            this_component.position_info.private_area =
              response.data["private_area"];
            this_component.position_info.region_code =
              response.data["region_code"];

            console.log(message);
            this_component.address_dialog = false;
            this_component.addressError = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          this_component.addressError = true;
        });
    },
    get_address_list: function(address_keyword) {
      var this_component = this;
      console.log('address_keyword_changed : ' + address_keyword)
      console.log('address_keyword_lenth : ' + address_keyword.length)
      // for test using postman
      // http://www.juso.go.kr/addrlink/addrLinkApiJsonp.do?confmKey=U01TX0FVVEgyMDE5MDMyNTE3NDIwNjEwODYwMTk=&currentPage=1&countPerPage=10&keyword=가양동&resultType=json
      this.$axios
        .post(this.$store.state.url_end_point + "/get_address_list", {
          keyword: address_keyword
        })
        .then(function(response) {
          console.log(response.data);
          var message = response.data["results"]["common"]["errorMessage"];

          if (message == "정상") {
            var _address_list = response.data["results"]["juso"];
            this_component.address_search_results = _address_list;

            console.log(_address_list);
          }
        })
        .catch(function(error) {
          console.log(error);
          this_component.addressError = true;
        });
    }
  },
  mounted: function() {
    
  },
  computed: {
    position_list: {
      get: function() {
        return this.$store.state.selected_portfolio.position_list;
      },
      set: function(p) {
        this.$store.state.selected_portfolio.position_list = p;
      }
    },
    selected_portfolio_title: {
      get: function() {
        return this.$store.state.selected_portfolio.title;
      },
      set: function(p) {
        this.$store.state.selected_portfolio.title = p;
      }
    }
  },
  watch: {
    position_info_position_type: function(val) {
      this.position_info.position_type = val;
      //console.log(this.position_info.position_type);
    },
    position_info_loan_type: function(val) {
      this.position_info.loan_type = val;
    }
    // position_info_position_type: {
    // // getter
    //   get: function () {
    //     return this.position_info.position_type
    //   },
    //   // setter
    //   set: function (newValue) {
    //     this.position_info.position_type = newValue
    //   }
    // }

    // position_list() {
    //     return this.$store.state.position_list;
    // },
  },
  created: function() {
    // var getCookie = function(name) {
    //   var nameEQ = name + "=";
    //   var ca = document.cookie.split(";");
    //   for (var i = 0; i < ca.length; i++) {
    //     var c = ca[i];
    //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
    //     if (c.indexOf(nameEQ) == 0){
    //       var cookie = c.substring(nameEQ.length, c.length);

    //       return cookie;
    //     }

    //   }
    //   return null;
    // }

    var position_token = this.$store.getters.getCookie("position_token");
    console.log("positioninfo_vue_created");
    console.log(position_token);
  }
};
</script>
